import Swiper from 'swiper';
import { Navigation , Pagination } from 'swiper';

import $ from 'jquery'; // Ensure jQuery is imported
import '@fancyapps/fancybox'; // Import Fancybox


export function imagesSlider() {
    $('.images-slider__wrapper').each(function(){
        let block = $(this);
        let slider = $(this).find('.images-slider__slider');
        let fullWidth = block.data('full-width');
        let slidesPerView = fullWidth ? 1 : 1.15;
        const imagesSlider = new Swiper(slider.get(0), {
            // Common parameters
            loop: false,
            slidesPerView: slidesPerView,
            centeredSlides: true,
            
            navigation: {
                nextEl: block.find('.swiper-button-next').get(0),
                prevEl: block.find('.swiper-button-prev').get(0),
            },
            pagination: {
                el: block.find('.swiper-pagination').get(0),
                clickable: true, // Makes the dots clickable
            },
            modules: [Navigation , Pagination],
        });
    });
    
    // Initialize Magnific Popup
    $('[data-fancybox="gallery"]').fancybox({
        showClass: false,
        hideClass: false,
        hash: false,
        buttons: ["close"], // Specify only the close button
        infobar: false, // Hide the infobar
        toolbar: true, // Keep the toolbar so the close button appears
        smallBtn: false, // Hide the small close button inside the content area
        arrows: false, // Hide navigation arrows
        animationEffect: "none",
        autoSize: true, // Ensures the content fits within the viewport.
        clickContent: false, // Disables zoom on click.
        margin: [44, 0, 44, 0],
        afterShow: function(instance, current) {
            // Assuming `current.$content` is the content area for the image
            // Check if our custom caption element exists, if not, create it
            let captionText = current.opts.$orig.data('caption');
            if (captionText) {
              // Check if a caption element already exists
              let captionElement = current.$content.find('.custom-caption');
              if (captionElement.length === 0) {
                // Create a new caption element if it doesn't exist
                captionElement = $('<div class="fancybox-custom-caption"></div>').appendTo(current.$content);
              }
              // Set the text for the caption element
              captionElement.html(captionText);
            }
        }
    });
}
